import { lead900 } from './colors';

export const typography = {
  fontFamily: '"Nunito", "Helvetica", sans-serif',
  body1: {
    color: lead900,
    fontSize: '1rem',
    lineHeight: 1.5,
  },
  h1: {
    fontSize: '2.5rem',
    fontWeight: 500,
    color: lead900,
  },
  h2: {
    fontSize: '2rem',
    fontWeight: 500,
    color: lead900,
  },
  button: {
    textTransform: 'none',
    fontWeight: 600,
  },
  pageTitle: {
    fontFamily: '"Calistoga", "Georgia", serif',
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: '31.2px',
    color: lead900,
  },
  sectionTitle: {
    fontFamily: '"Nunito", "Helvetica", sans-serif',
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '27px',
    color: lead900,
  },
  storeName: {
    fontFamily: '"Calistoga", "Georgia", serif',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '20.8px',
    color: lead900,
  },
};
